<template>
  <v-container>
    <div class="breadcrumb-wrap">
      <v-breadcrumbs :items="breadcrumbs" />
    </div>
    <div class="form-npa edit law-edit">
      <div class="position">
        <div class="bg-white p-20">
          <form action="">
            <div class="form_head">
               <h3 class="form_head-title">

               </h3>
            </div>
            <LawNormForm
              v-if="normData"
              page="edit"
              :options="normData"
              :law="law"
              :edit-form="form"
              :error="error"
              @create="create"
              :law-to-change="lawToChange"
              @update:lawToChange="lawToChange = $event"
            />
          </form>
        </div>
      </div>
    </div>
  </v-container>
</template>
<script>
import { mapGetters, mapMutations } from 'vuex'
import LAW from '@/model/law'
import {Trans} from "@/plugins/Translation"
import LawNormForm from '@/components/law/LawNormForm.vue'

export default {
  name: 'NormEdit',
  components: {
    LawNormForm
  },
  data () {
    return {
      breadcrumbs: [],
      form: {
        norm: {
          params: {
            law_id: null,
            article_value: 'Весь документ',
            by_law_id: [],
            article_id: null,
            developers: [],
          },
          implementationPeriod: null,
          normText: null,
          normTextKg: null,
          executionNorm: 0,
          article_part: '',
          law_changes_required: false,
          law_to_change_id: null,
        },
        article: {
          name: null,
          nameKg: null,
          text: null,
          textKg: null,
          law: null
        },
      },
      law: null,
      normData: null,
      error: {
        status: false,
        message: ''
      },
      norm: null,
      lawToChange: null,
    }
  },

  mounted() {
    this.fetchData()
  },

  methods: {
    ...mapMutations(['setLoading']),
    // генерация хлебных крошек
     generateBreadcrumbs(name) {
      this.breadcrumbs = [
        {text: this.$i18n.t('Профиль'), disabled: false, href: Trans.currentLocaleUrl + '/profile'},
        {text: this.$i18n.t('Исполнение законов'), disabled: false, href: Trans.currentLocaleUrl + '/law'},
        {text: this.law.transName, disabled: false, href: Trans.currentLocaleUrl + '/law-view/' + this.law.id},
        {text: this.$i18n.t('Редактирование нормы'), disabled: true},
      ]
    },

    fetchData() {
      this.setLoading(true)

      LAW.getNorm(this.$route.params.id).then((response) => {
        this.law = response.data.law
        this.norm = response.data
        this.lawToChange = this.norm?.law_to_change
        this.constructionNorm(response.data)
        this.generateBreadcrumbs(response.data.normText)
        this.setLoading(false)

        LAW.getLaw(this.law.id).then((lawResponse) => {
          this.law = lawResponse.data.law
          this.law.byLaws = lawResponse.data.byLaws
        }).catch((error) => {
          console.log(error)
        })


        LAW.getNormData().then((response) => {
          this.normData = response.data
        }).catch((error) => {
          console.log(error)
        });


      }).catch((error) => {
        console.log(error)
      })
    },

    create(data) {
      if (data.form.norm.executionNorm == 1 && !data.isAddLegalAct && data.form.norm.params.by_law_id.length == 0) {
        this.error.status = true
        this.error.message = 'Выберите из существующих подзаконных актов или создайте новую'
      } else {
        this.setLoading(true)
        if (!data.selectedExistingArticle && data.form.norm.params.article_value == 'Статья') {
          LAW.createLawArticle(data.form.article).then((response) => {
            data.form.norm.params.article_id = response.data.id
            this.createByLaw(data)
          }).catch((error) => {})
        } else {
          this.createByLaw(data)
        }
      }

      },

      createByLaw(data) {
        console.log(data)
        let newNorm = {
          id: this.$route.params.id,
          executionNorm: data.form.norm.executionNorm,
          developers: data.form.norm.params.developers,
          article: data.form.norm.params.article_id,
          article_part: data.form.norm.article_part,
          byLaw: data.form.norm.params.by_law_id,
          law: this.law.id,
          normText: data.form.norm.normText,
          normTextKg: data.form.norm.normTextKg,
          implementationPeriod: data.form.norm.implementationPeriod,
          law_changes_required: data.form.norm.law_changes_required,
          law_to_change_id: data.form.norm.law_to_change_id,
        }

        if (data.isAddLegalAct) {
          LAW.createByLaw(data.legalAct).then((response) => {
            data.form.norm.params.by_law_id.push(response.data.id)
            LAW.editNorm(newNorm).then(() => {
              this.pushLawView()
            }).catch((error) => {
              this.pushLawView()
            })

          }).catch((error) => {
            this.pushLawView()
          })
        } else {
          LAW.editNorm(newNorm).then(() => {
            this.pushLawView()
          }).catch((error) => {
            this.pushLawView()
          })
        }
      },

    pushLawView () {
      this.$router.push({ name: 'law-view', params: { id: this.law.id } })
    },

    constructionNorm (data) {
      this.form = {
        norm: {
          params: {
            law_id: data.law?.id,
            article_value: data.article != null ? 'Статья' : 'Весь документ',
            by_law_id: data.byLaw == null ? [] : this.getByByLaws(data.byLaw),
            article_id: data.article == null ? null : data.article?.id,
            developers: data.developers,
          },
          implementationPeriod: data.implementationPeriod,
          normText: data.normText,
          normTextKg: data.normTextKg,
          executionNorm: data.executionNorm?.id,
          article_part: data.article_part,
          law_changes_required: data.law_changes_required,
          law_to_change_id: data.law_to_change_id,
        },
        article: {
          law_id: data.law?.id,
          article_id: data.article == null ? null : data.article?.id,
          article_number: data.article == null ? null : data.article?.number,
        }
      }
    },

    getByByLaws (byLaws) {
      return byLaws.map(item => item.id)
    }
  }
}
</script>
